<template>
  <div class="grid-container full pane-control-row">
    <div class="grid-x">
      <div class="small-1 cell">
&nbsp;
      </div>
      <div class="small-10 cell text-center">
        <h4 class="graph-title control-title">
          {{ title }}
        </h4>
      </div>
      <div class="small-1 cell text-right">
        <rare-expand-collapse-button
          @changePaneState="changePaneState"
        />
      </div>
    </div>
  </div>
</template>

<script>

import RareExpandCollapseButton from '../controls/RareExpandCollapseButton.vue';

export default {
  name: 'RarePaneControl',
  components: {
    RareExpandCollapseButton,
  },
  props: {
    title: {
      required: true,
      type: String,
    },
    paneToControl: {
      required: true,
      type: String,
    },
  },
  methods: {
    changePaneState() {
      this.$emit('changePaneState', this.paneToControl);
    },
  },
};
</script>

<style lang="scss" scoped>

@import "~@/css/global.scss";

.control-title {
  margin-bottom: 0;
  display: inline-block;
  background-color: #ffffff;
  padding: 0 10px;
  text-align: center;
}

.pane-control-row {
  margin-top: 24px;
  background: linear-gradient(180deg,
    rgba(0,0,0,0) calc(50% - 1px),
    rgba(180, 191, 200, 1) calc(50%),
    rgba(0,0,0,0) calc(50% + 1px)
  );
}

</style>
